<script setup lang="ts">
import SadImage from "@/assets/images/sad.png";
import { useModalManager } from "@/composables/useModalManager";
import { usePayments } from "@/composables/usePayments";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import { ModalEnum } from "@/types/enums";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import BaseModal from "./BaseModal.vue";

const { activeModal } = useModalManager();
const { makePayment } = usePayments();
const router = useRouter();
const authStore = useAuthenticationStore();
const show = ref(false);
const loading = ref(false);

watch(
  () => activeModal.value,
  (modal) => {
    show.value = modal === ModalEnum.PaymentFailedModal;
  },
  { immediate: true },
);

const onClose = () => {
  router.replace({ query: {} });
  show.value = false;
  activeModal.value = null;
};

const goToContactUs = () => {
  onClose();
  router.push({ name: "contact-us" });
};

const retryPayment = async () => {
  loading.value = true;
  await makePayment(authStore.user);
};
</script>

<template>
  <BaseModal @close="onClose" width="780px" :hideHead="true" v-model:visible="show">
    <div class="flex flex-col items-center justify-center p-1 pb-4 text-center md:p-4">
      <img :src="SadImage" alt="Success" class="mx-auto mb-4 h-32 w-32" />
      <h2 class="text-[2rem] font-bold text-rose-600">Payment failed!</h2>
      <div class="mt-2 flex flex-col gap-2 text-[1.025rem] font-medium text-black md:gap-0">
        <span
          >Your payment could not be processed. Please check your payment details and try
          again.</span
        >
        <span
          >If the problem persists, please
          <Button @click="goToContactUs" text class="!p-0 hover:bg-transparent"
            ><span class="text-sky-500 underline">contact</span></Button
          >
          our support team for assistance.
        </span>
      </div>
      <Button
        class="mt-4 min-w-[200px] border-rose-600 bg-rose-600 px-4 py-2"
        @click="retryPayment"
        :disabled="loading"
      >
        <i v-if="loading" class="pi pi-spin pi-spinner text-white"></i>
        <span class="font-semibold text-white">Retry Payment</span>
      </Button>
      <Button
        @click="onClose"
        text
        class="!mt-2 bg-transparent hover:bg-transparent hover:underline"
        ><span>Cancel</span></Button
      >
    </div>
  </BaseModal>
</template>
